import type { JsonResponse, DaznLink } from './interfaces';
import { useRequest } from './useRequest';

export const useReadLinksAPI = () => {
  const request = useRequest<JsonResponse<DaznLink[]>>();

  return async () => {
    return request('/links');
  };
};
